<template>
  <v-card flat>
    <v-card-text class="text-xs-center">
      <v-container fluid grid-list-xs>
        <v-layout row wrap>
          <v-flex xs12 sm12 md4 offset-md4>
            <form id="form-checkout" @submit.prevent="submit_payment">

              <v-flex xs12 md12 class="pt-0 pb-0">
                <v-text-field v-model="mercadoAmount"
                  :disabled="!!preference_id"
                  class="pt-0 pb-0"
                  name="mercadoAmount"
                  :label="$t('attrs.amount')"
                  v-validate="`required|min_value: ${ mercadoValidAmount }`"
                  :error-messages="errors.collect('mercadoAmount')"
                  data-vv-name="mercadoAmount"
                  :data-vv-as="$t('attrs.amount')"
                  :hint="$t('mercadoHint')"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>


              <v-flex xs12 md12 mt-2 class="pt-0 pb-0 mt-2" v-if="!preference_id">
                <v-btn color="primary" :loading="loading" type="submit" id="form-checkout__submit" :disabled="loading">Pagar</v-btn>
              </v-flex>

              <v-flex xs12 md12 class="pt-0 pb-0 mercadoPagoPayment">
              </v-flex>

              <template v-if="parseFloat(this.mercadoAmount) >= parseFloat(this.mercadoValidAmount)">
                <v-flex xs12 md12 class="pt-0 pb-0 mt-4 text-center">
                  {{ $t(`mercadoDepositDetail`) }}
                </v-flex>

                <v-flex xs12 md12 mt-2 class="pt-0 pb-0 text-center">
                  <table class="mercado-table">
                    <tr class="mercado-row">
                      <td>{{ $t('deposit') }}:</td>
                      <td> {{ mercadoAmount | currency }} </td>
                    </tr>
                    <tr class="mercado-row">
                      <td>{{ $t('commission') }}:</td>
                      <td> {{ deduction | currency }} </td>
                    </tr>
                    <tr class="mercado-row" :style="`color: ${ appColor }`">
                      <td> {{ $t('mercadoAddedCredits') }} </td>
                      <td> {{ finalMercadoAmount | currency }} </td>
                    </tr>
                  </table>
                </v-flex>
              </template>
            </form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style type="text/css" scoped>
  .no-focus:focus-visible {
    outline:  none;
  }

  .mercado-row {
    display: flex !important;
    justify-content: space-between;
    width: 100%;
  }

  .mercado-table {
    margin: 0 auto;
    width: 70%;
  }

  .mercado-table tr {
    margin-top: 10px !important;
  }
</style>

<script src="https://www.mercadopago.com.br/integrations/js/v2.js" type="text/javascript"></script>
<script>
import Setting from '@/client/setting'
import TransferFund from '@/client/transfer-fund'
export default {
  name: '',

  props: {},

  data () {
    return {
      card: {},
      progress: '',
      access_token_present: false,
      data_invalid: false,
      preference_id: null,
      loading: false,
      mercadoAmount: '0',
      formMounted: false,
      mercadoKeysPresent: false,
      appColor: process.env.VUE_APP_COLOR,
      deduction: 0,
      finalMercadoAmount: 0,
      mercadoValidAmount: 10
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async setPaymentForm () {
      const mp = new MercadoPago(this.mercado_pago_public_key, {
        locale: 'en-US'
      })
      mp.checkout({
          preference: {
            id: this.preference_id
          },
          render: {
            container: '.mercadoPagoPayment', // Indica dónde se mostrará el botón de pago
            label: 'Pagar con Mercado Pago', // Cambia el texto del botón de pago (opcional)
            type: 'wallet', // Aplica la marca de Mercado Pago al botón
          }
      });

    },

    async submit_payment () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      if (!this.mercadoKeysPresent || (this.preference_id && this.access_token_present) || this.data_invalid){
        if(!this.mercadoKeysPresent || this.data_invalid){
          this.setNotification({
            color: 'error',
            message: this.$t('invalidSettings')
          })
        }
      } else {
        this.errors.clear()
        try {
          this.loading = true
          const data = await TransferFund.mercadoPagoCreatePreference({
            amount: this.mercadoAmount
          })
          this.preference_id = data['preference_id']
          this.access_token_present = data['access_token_present']
          this.mercado_pago_public_key = data['mercado_pago_public_key']
          this.data_invalid = data['data_invalid']
          this.setPaymentForm()
        } catch (err) {
          this.handleErr(err)
        }
        this.loading = false

        //clicks mercado pago payment button
        document.querySelector('.mercadopago-button').click()
      }
    }
  },

  watch: {
    mercadoAmount () {
      var amount = parseFloat(this.mercadoAmount)
      if ( amount >= parseFloat(this.mercadoValidAmount) ) {
        //mercado calculation
        // this.deduction = (((amount * 0.03) + 4) + 1.16)
        this.deduction = (((amount * 0.0379) + 4) + 1.16)
        this.finalMercadoAmount = (amount - this.deduction)
      }
    },
  },

  async mounted () {
    this.settings = await Setting.all()

    try {
      var accessToken = this.settings.find(o => o.key === 'mercado_pago_access_token').value
      var publicKey = this.settings.find(o => o.key === 'mercado_pago_public_key').value
    } catch (err) {
      this.mercadoKeysPresent = false
    }

    if (accessToken && publicKey) {
      this.mercadoKeysPresent = true
    }

    if ( this.$route.query.success === 'true' ) {
      await this.$auth.getCurrentUser()
      this.setNotification({
        color: 'success',
        message: this.$t('amountCredited')
      })
    }

    this.mercadoValidAmount = this.settings.find(o => o.key === 'mercado_min_amount').value || 10
    // let mercadoScript = document.createElement('script')
    // mercadoScript.setAttribute('src', 'https://sdk.mercadopago.com/js/v2')
    // document.head.appendChild(mercadoScript)
  }
}
</script>
